@if (security?.RequiredFunctionalities?.length) {
  <div>
    <h6>Required functionalities</h6>
    @for (item of security?.RequiredFunctionalities; track item) {
      <span class="body-1">
        {{item.Functionality}}: {{translateScope(item.Scope)}}
      </span>
    }
  </div>
}
<mat-divider></mat-divider>
<div class="spacer">
  <h6>Required user type</h6>
  <span class="body-1">
    {{translateUserType($safeNavigationMigration(security?.RequiredUserType))}}
  </span>
</div>
<mat-divider></mat-divider>
<div class="spacer">
  <h6>Requires authentication</h6>
  <span class="body-1">
    {{security?.RequiresAuthentication ? "Yes" : "No"}}
  </span>
</div>
<mat-divider></mat-divider>
